// filepath: /Users/shiva/Dev/react-app/src/contexts/Auth0ProviderWithNavigate.tsx
import React, { ReactNode } from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { environment } from 'environments/environment';

// Get Auth0 configuration from environment
const authConfig = environment.services.auth;
// Make sure the domain has the https:// prefix
const domain = authConfig.auth0Domain.includes('https://') 
  ? authConfig.auth0Domain 
  : `https://${authConfig.auth0Domain}`;
const clientId = authConfig.auth0ClientId;
// Use the configured callback URL or fallback to window.location.origin
const redirectUri = authConfig.auth0CallbackURL || window.location.origin;

interface Auth0ProviderWithNavigateProps {
  children: ReactNode;
}

const Auth0ProviderWithNavigate: React.FC<Auth0ProviderWithNavigateProps> = ({ children }) => {
  const navigate = useNavigate();

  // Handle redirect callback after authentication
  const onRedirectCallback = (appState: any) => {
    // Navigate to the URL provided in appState or default to home
    navigate(appState?.returnTo || '/');
  };

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: redirectUri,
        scope: 'openid profile email'
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithNavigate;